import { ContactInformationDisplayModelFormGroup } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/contact-information-display-model';
import { StateService } from '@/core/services/state.service';
import { Component, Input, OnInit } from '@angular/core';
import { emailValidator, phoneValidator } from '@/core/validators/customform.validators';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'contact-information',
  templateUrl: './contact-information.component.html',
  styleUrls: ['./contact-information.component.scss']
})
export class ContactInformationComponent implements OnInit {
  @Input("form")
  public contactInformationForm: ContactInformationDisplayModelFormGroup;
  @Input("isRequired")
  public required: boolean = true;
  @Input("isAntragsteller") 
  public kontaktIsAntragsteller: boolean = false;

  constructor(
    protected stateService: StateService,
    protected translateService: TranslateService
    ) {
  }

  ngOnInit(): void {
    this.contactInformationForm.EmailAddress.addValidators(emailValidator);
    this.contactInformationForm.TelephoneNumber.addValidators(phoneValidator);

    if (this.stateService.IsEndvalidationEnabled && this.required) {
      this.contactInformationForm.EmailAddress.addValidators(Validators.required);
      this.contactInformationForm.TelephoneNumber.addValidators(Validators.required);
      this.contactInformationForm.markAllAsTouched();
    }
  }

  get emailErrorMessage(): string {
    if (this.contactInformationForm.get('emailAddress')?.errors?.email)
      return this.translateService.instant('contactinformation.emailAddress.invalid');

    return "";
  }
  
  get telephoneNumberErrorMessage(): string {
    if (this.contactInformationForm.get('telephoneNumber')?.errors?.phone)
      return this.translateService.instant('contactinformation.telephoneNumber.invalid');

    return "";
  }
}
